export default __webpack_public_path__ + "edit-location.ff8959db3b8521354dd306bd15c0f370.svg";